import { render, staticRenderFns } from "./ViewDetail.vue?vue&type=template&id=635447e2&scoped=true"
import script from "./ViewDetail.vue?vue&type=script&lang=js"
export * from "./ViewDetail.vue?vue&type=script&lang=js"
import style0 from "./ViewDetail.vue?vue&type=style&index=0&id=635447e2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "635447e2",
  null
  
)

export default component.exports